import * as Yup from 'yup';

export const DischargeSchema = Yup.object().shape({
  mastery_of_goals: Yup.string().trim().required().min(60),
  readiness_to_move_on_from_current_service: Yup.string().trim().required().min(60),
  step_down_in_program_hours: Yup.string().trim().required().min(60),
  communication_amongst_providers: Yup.string().trim().required().min(60),
});

export const initialDischargeCriteria = {
  mastery_of_goals: '',
  readiness_to_move_on_from_current_service: '',
  step_down_in_program_hours: '',
  communication_amongst_providers: '',
};
